// Configuração das colunas especiais do Kanban
// Este arquivo permite adicionar/remover colunas dinâmicas facilmente

import { StatusReference } from "@/pages/Projects/Utils/StatusConstants.js";

// Configuração das colunas especiais
export const SPECIAL_COLUMNS_CONFIG = [
  {
    id: 'declinados',
    name: 'Declinados',
    icon: require("@/assets/projects/Declinado.png"), // Troque por ícone apropriado
    color: '#FF5722',
    description: 'Projetos que foram declinados pelo cliente',
    filterFunction: (project, isFranchisee) => {
      const currentStatus = isFranchisee ? project.currentStatusFranchisee : project.currentStatusADM;
      // Status que indicam projeto declinado (apenas status específicos de declinado)
      const declinedStatuses = [2001,2002]; 
      return declinedStatuses.includes(currentStatus);
    }
  },
  {
    id: 'reprovados',
    name: 'Reprovados',
    icon: require("@/assets/projects/Reprovado.png"), // Troque por ícone apropriado
    color: '#F44336',
    description: 'Projetos que foram reprovados na análise',
    filterFunction: (project, isFranchisee) => {
      const currentStatus = isFranchisee ? project.currentStatusFranchisee : project.currentStatusADM;
      // Status que indicam projeto reprovado
      const rejectedStatuses = [101,106,201,207,2003,2004]; 
      return rejectedStatuses.includes(currentStatus);
    }
  },
  {
    id: 'inativos',
    name: 'Inativos',
    icon: require("@/assets/projects/Inativo.png"), // Troque por ícone apropriado
    color: '#9E9E9E',
    description: 'Projetos sem atividade recente',
    filterFunction: (project, isFranchisee) => {
      const currentStatus = isFranchisee ? project.currentStatusFranchisee : project.currentStatusADM;
      
      // Status que indicam projeto declinado ou reprovado
      const declinedStatuses = [2001, 2002]; // Declinados
      const rejectedStatuses = [101, 106, 201, 207, 2003, 2004]; // Reprovados
      
      // Se o projeto está declinado ou reprovado, não deve aparecer em inativos
      if (declinedStatuses.includes(currentStatus) || rejectedStatuses.includes(currentStatus)) {
        return false;
      }
      
      // Verifica se o projeto está finalizado (step "finish")
      const currentStep = project.steps?.find(step => step.isCurrentStep === true);
      if (currentStep && currentStep.name === 'finish') {
        return false; // Projeto finalizado não deve aparecer em inativos
      }
      
      const lastActivity = isFranchisee ? project.currentHourStatusFranchisee : project.currentHourStatusADM;
      const lastActivityDate = new Date(lastActivity || project.created_at_formatted);
      const now = new Date();
      const daysInactive = (now - lastActivityDate) / (1000 * 60 * 60 * 24);
      
      // Considera inativo se não houve atividade nos últimos 120 dias
      return daysInactive > 120;
    }
  }
];

// Função para adicionar nova coluna especial
export function addSpecialColumn(columnConfig) {
  const newColumn = {
    id: columnConfig.id,
    name: columnConfig.name,
    icon: columnConfig.icon || require("@/assets/projects/fz_approval.png"),
    color: columnConfig.color || '#9E9E9E',
    description: columnConfig.description || '',
    filterFunction: columnConfig.filterFunction || (() => false),
    type: 'special'
  };
  
  SPECIAL_COLUMNS_CONFIG.push(newColumn);
  return newColumn;
}

// Função para remover coluna especial
export function removeSpecialColumn(columnId) {
  const index = SPECIAL_COLUMNS_CONFIG.findIndex(col => col.id === columnId);
  if (index !== -1) {
    SPECIAL_COLUMNS_CONFIG.splice(index, 1);
    return true;
  }
  return false;
}

// Função para obter todas as colunas especiais
export function getSpecialColumns() {
  return SPECIAL_COLUMNS_CONFIG.map(col => ({
    id: col.id,
    name: col.name,
    icon: col.icon,
    color: col.color,
    type: 'special'
  }));
}

// Função para obter configuração de uma coluna específica
export function getSpecialColumnConfig(columnId) {
  return SPECIAL_COLUMNS_CONFIG.find(col => col.id === columnId);
}

// Exemplo de como adicionar uma nova coluna:
/*
addSpecialColumn({
  id: 'urgentes',
  name: 'Urgentes',
  icon: require("@/assets/projects/fz_approval.png"),
  color: '#FF1744',
  description: 'Projetos com alta prioridade',
  filterFunction: (project, isFranchisee) => {
    // Sua lógica para determinar projetos urgentes
    return project.priority === 'high';
  }
});
*/